import React, { useState, useEffect, useRef } from 'react';
import urls from "../../api/urls.json";
import styled from 'styled-components';
import Loader from "../Loader";
import placeholder_image from "../../assests/placeholder_image.png"
import LeftNav from "../LeftNav";
import { useLocation, useNavigate } from "react-router-dom";
import '../styles/Member.css';
import { css } from 'styled-components';
import PageModal from "../modals/PageModal";

import {
    GapView
} from '../../styles/WrapperStyles';

import {
    MemberSearchInput,
    MemberSearchText,
} from '../../styles/TextStyles';


import { BaseButton } from '../../styles/ButtonStyles';
import ListModal from '../modals/ListModal';
import MemberDetailedView from './MemberDetailedView';
import { authorizedHttpGet, authorizedHttpPost } from '../../api/httpCalls';
import { FlexWrapper } from '../../styles/WrapperStyles'


const HeaderWrapper = styled(FlexWrapper)`
    cursor: pointer; 
    // display: inline;
    height: 55px;  
    padding: 0 30px 0 30px;
    border-radius: 27.5px;
    background-color: #f8f8fa;
    align-items:center;
    margin-top: 25px;   
    position: absolute;
    ${props => props.width && css`
        width:${props.width}
    `}
`;


const Par = styled.div`
  display: flex;
  width: 100%;
  height: max-content;
  marggin-left: 200px
`;

const RightDiv = styled.div`
  padding: 0px 20px;
  height: max-content;
  border-radius: 30px;
  background-color: #f8f8fa;
`;

const HeaderSelected = styled.span`
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  font-weight: 800;
  color: #767676
    ${props =>
        props.marginRight &&
        css`
        margin-right: 10px;
      `};
`;


function Member() {
    const location = useLocation();
    const navigate = useNavigate();
    const authToken = localStorage.getItem('authToken');
    const isOtpVerified = localStorage.getItem('verificationPassed');
    if (!authToken || !isOtpVerified) {
        sessionStorage.setItem('redirectUrl', location.pathname)
        navigate('/login')
    }
    const [appName, setAppName] = useState(localStorage.getItem('appName'))
    const [firstName, setFirstName] = useState('');
    const [age, setAge] = useState('');
    const [height, setHeight] = useState('');
    const [faith, setFaith] = useState('');
    const [motherTongue, setMotherTongue] = useState('');
    const [status, setStatus] = useState('');
    const [sunSign, setSunSign] = useState('');
    const [city, setCity] = useState('');
    const [iceBreaker, setIceBreaker] = useState('');
    const [listItem, setListItem] = useState('');
    const [dropDownValues, setDropDownValues] = useState({});
    const [loading, setLoading] = useState(false);
    const apiPageChange = useRef(1);
    const [profilesList, setProfilesList] = useState([]);
    const [profileDetailedView, toggleProfileDetailedView] = useState(false);
    const [detailedViewRef, setDetailedViewRef] = useState(null);
    const [totalPages, setTotalPages] = useState(1);
    const [displayPageModal, setDisplayPageModal] = useState(false);

    const resetFilters = () => {
        setFirstName('');
        setAge('');
        setHeight('');
        setFaith('');
        setMotherTongue('');
        setStatus('');
        setSunSign('');
        setCity('');
        setIceBreaker('');
    }

    const handleLeftNavAppChange = (name) => {
        setProfilesList([]);
        resetFilters();
        setAppName(name)
    };

    const getListItem = () => {
        if (listItem === 'age') {
            return ageList;
        } else if (listItem === 'height') {
            return heightList;
        } else if (listItem === 'faith') {
            return dropDownValues.faiths;
        } else if (listItem === 'motherTongue') {
            return dropDownValues.languages;
        } else if (listItem === 'status') {
            return dropDownValues.statuses;
        } else if (listItem === 'sunSign') {
            return dropDownValues.sun_signs;
        }
    }

    const getDropDownValues = async () => {
        setLoading(true);
        let response = await authorizedHttpGet(urls.GET_MEMBER_SEARCH_DROPDOWN);
        if (response.status) {
            setDropDownValues(response.data);
        }
        setLoading(false);
    }

    useEffect(() => {
        getDropDownValues();
        toggleProfileDetailedView(false);
    }, [appName]);


    // modals
    const [displayModal, setDisplayModal] = useState(false);

    var heightList = [];
    for (var i = 48; i <= 96; i++) {
        heightList.push({
            id: i,
            name: Math.floor(i / 12) + "' " + (i % 12) + '"'
        });
    }
    var ageList = [];
    for (var i = 18; i <= 110; i++) {
        ageList.push({
            id: i,
            name: i
        });
    }

    const closeModal = () => {
        setDisplayModal(false);
    }

    const itemSelected = (item) => {
        if (listItem === 'age')
            setAge(item.name);
        else if (listItem === 'height')
            setHeight(item.name);
        else if (listItem === 'faith')
            setFaith(item.name);
        else if (listItem === 'motherTongue')
            setMotherTongue(item.name);
        else if (listItem === 'status')
            setStatus(item.name);
        else if (listItem === 'sunSign')
            setSunSign(item.name);
        closeModal();
    }

    const handleDropDownChange = (item) => {
        setListItem(item);
        setDisplayModal(true);
    }

    const fetchId = (type, value) => {
        let id;
        if (type === 'faith') {
            dropDownValues.faiths.map((item) => {
                if (item.name === value) {
                    id = item.id;
                }
            })
        }
        else if (type === 'language') {
            dropDownValues.languages.map((item) => {
                if (item.name === value) {
                    id = item.id;
                }
            })
        }
        else if (type === 'status') {
            dropDownValues.statuses.map((item) => {
                if (item.name === value) {
                    id = item.id;
                }
            })
        }
        else if (type === 'sunSign') {
            dropDownValues.sun_signs.map((item) => {
                if (item.name === value) {
                    id = item.id;
                }
            })
        }
        return id;
    }

    const getParams = () => {
        let params = {};
        params.page = apiPageChange.current;
        if (firstName !== '') {
            params.first_name = firstName;
        }
        if (age !== '') {
            params.age = age;
        }
        if (height !== '') {
            params.height = heightList.find((item) => item.name === height).id;
        }
        if (faith !== '') {
            params.faith_id = fetchId('faith', faith);
        }
        if (motherTongue !== '') {
            params.language_id = fetchId('language', motherTongue);
        }
        if (status !== '') {
            params.status_id = fetchId('status', status);
        }
        if (sunSign !== '') {
            params.sun_sign_id = fetchId('sunSign', sunSign);
        }
        if (city !== '') {
            params.city = city;
        }
        if (iceBreaker !== '') {
            params.ice_breaker = iceBreaker;
        }
        return params;
    }

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === 'Enter') {
                handleSubmit();
            }
        };
        document.addEventListener('keydown', handleKeyPress);
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    });

    const handleSubmit = async () => {
        setLoading(true);
        let response = await authorizedHttpGet(urls.GET_MEMBER_SEARCH, getParams());
        if (response.status) {
            setTotalPages(response.data.total_pages);
            setProfilesList(response.data.profile_list);
        }
        setLoading(false);
    }

    useEffect(() => {
        apiPageChange.current = 1;
        setTotalPages(1);
    }, [appName])

    const goToPage = async (pageModalNumber) => {
        if (pageModalNumber > totalPages) {
            alert("Page number is greater than total pages");
            setDisplayPageModal(false);
            return;
        }
        apiPageChange.current = pageModalNumber;
        setLoading(true);
        let response = await authorizedHttpGet(urls.GET_MEMBER_SEARCH, getParams());
        if (response.status) {
            setTotalPages(response.data.total_pages);
            setProfilesList(response.data.profile_list);
        }
        setLoading(false);
        setDisplayPageModal(false);
    }

    useEffect(() => {
        // handleSubmit();
    }, [apiPageChange.current])

    return (
        <div className='App'>
            <LeftNav handleLeftNavAppChange={handleLeftNavAppChange} tabName={'Member'} />
            {
                profileDetailedView ? <MemberDetailedView detailedViewRef={detailedViewRef} closeDetailedView={() => toggleProfileDetailedView(false)} viewType={"Member"} /> :
                    <Par className='marginLeft200'>
                        {displayPageModal && <PageModal goToPage={goToPage} page={apiPageChange.current} closeModal={() => setDisplayPageModal(false)} />}
                        {loading && <Loader />}
                        {displayModal && <ListModal closeModal={closeModal} list={getListItem(listItem)} itemSelected={itemSelected} />}
                        <HeaderWrapper onClick={() => setDisplayPageModal(true)}>
                            <HeaderSelected>{apiPageChange.current}</HeaderSelected>
                            <HeaderSelected className='marginLeft10'>{totalPages}</HeaderSelected>
                        </HeaderWrapper>
                        <div className='initialResults'>
                            {
                                profilesList.map((item) => {
                                    return (
                                        <div className='memberProfileInfoDiv' onClick={() => { toggleProfileDetailedView(true); setDetailedViewRef(item.ref) }}>
                                            <img className='marginRight20' width={250} height={250} src={item.image_url} onError={(e) => e.target.src = placeholder_image} />
                                            <p>{item.first_name}</p>
                                        </div>
                                    );
                                })
                            }
                        </div>

                        <RightDiv>
                            <MemberSearchText>Name</MemberSearchText>
                            <MemberSearchInput value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                            <MemberSearchText>Age</MemberSearchText>
                            <MemberSearchInput readOnly value={age} onClick={() => handleDropDownChange('age')} />
                            <MemberSearchText>Height</MemberSearchText>
                            <MemberSearchInput readOnly value={height} onClick={() => handleDropDownChange('height')} />
                            <MemberSearchText>Faith</MemberSearchText>
                            <MemberSearchInput readOnly value={faith} onClick={() => handleDropDownChange('faith')} />
                            <MemberSearchText>Mother Tongue</MemberSearchText>
                            <MemberSearchInput readOnly value={motherTongue} onClick={() => handleDropDownChange('motherTongue')} />
                            <MemberSearchText>Status</MemberSearchText>
                            <MemberSearchInput readOnly value={status} onClick={() => handleDropDownChange('status')} />
                            <MemberSearchText>Sun Sign</MemberSearchText>
                            <MemberSearchInput readOnly value={sunSign} onClick={() => handleDropDownChange('sunSign')} />
                            <MemberSearchText>City</MemberSearchText>
                            <MemberSearchInput value={city} onChange={(e) => setCity(e.target.value)} />
                            {
                                appName === 'Aisle' ? <MemberSearchText>Ice Breaker/Story</MemberSearchText> : <MemberSearchText>Ice Breaker</MemberSearchText>
                            }
                            <MemberSearchInput value={iceBreaker} onChange={(e) => setIceBreaker(e.target.value)} />
                            <div>
                                <BaseButton onClick={() => handleSubmit()}>Search</BaseButton>
                                <GapView height="12px" />
                                <BaseButton onClick={() => resetFilters()}>Reset</BaseButton>
                                <GapView height="12px" />
                            </div>
                        </RightDiv>
                    </Par >
            }
        </div>

    );

}




export default Member;
